import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["entities", "parent"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import MenuItemRender from './MenuItemRender';
import { buildPropsQuery, getEntityData, getRequiredSchemas, getUnpublishedEntityName, getUpdatedFilterBy, filterQuerySetup, filtersSetup, getUpdatedItemsToDisplay, getUpdatedSortProperties, shouldReturn, shouldSkipSingleQuery } from '../../helpers';
import { useGetEntitySchemasAsObj } from '../../hooks';
import { generateSingleItemQuery } from '../../application/query';
import { AND, SEARCH_PUBLISHED_CONTENT } from '../../constants';
const MenuEntitiesItem = _ref => {
  let {
      entities,
      parent
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    itemEntity: parentEntity,
    itemId: parentId
  } = parent;
  const {
    operator: filterOperator = AND,
    filterByProperty = [],
    sortProperties = [],
    itemsToDisplay,
    filterBy = [],
    sortby,
    sort
  } = props;
  const unpublishedEntityName = getUnpublishedEntityName(parentEntity);
  const [updatedSortProperties, sortbyFilters] = getUpdatedSortProperties(sort, sortby, sortProperties);
  const {
    data: mainSchemas = {},
    loading: entityObjloading,
    error: entityObjError
  } = useGetEntitySchemasAsObj([unpublishedEntityName, ...entities]);
  const [filterEntity] = entities;
  const {
    [filterEntity]: filterEntitySchema = {}
  } = mainSchemas;
  const entitiesTypes = entities.map(entity => getEntityData(entity, mainSchemas[entity]));
  const graphqlEntityMap = entitiesTypes.reduce((acc, entityType) => _objectSpread(_objectSpread({}, acc), {}, {
    [entityType.entityType]: entityType.entity
  }), {});
  const docTypes = entitiesTypes.map(({
    docType
  }) => docType);
  const entityTypes = entitiesTypes.map(({
    entityType
  }) => entityType);
  const entityFields = buildPropsQuery(filterEntitySchema, ['name', 'url']) || '';
  const parentSchema = mainSchemas[unpublishedEntityName] || {};
  const {
    entitySameAsCurrentItemEntity,
    filterEntityRelations,
    inheritedFilters,
    queryProps,
    getAction,
    action
  } = filtersSetup({
    itemEntityUpdated: unpublishedEntityName,
    currentSchema: parentSchema,
    filterEntitySchema,
    filterByProperty,
    entityFields,
    entityTypes,
    filterBy,
    entities
  });
  const {
    data: {
      entityData: parentEntityData = {}
    } = {},
    error: singleItemQueryError,
    loading: singleItemQueryLoading
  } = useQuery(generateSingleItemQuery(getAction, queryProps), {
    variables: {
      id: parentId
    },
    skip: shouldSkipSingleQuery(entityObjloading, getAction, queryProps)
  });
  const {
    data: requiredSchema = {},
    loading: schemaLoading,
    error: schemaError
  } = useGetEntitySchemasAsObj(getRequiredSchemas([...filterByProperty, ...sortbyFilters], filterEntitySchema), entityObjloading);
  const getEntitySchemas = Object.values(requiredSchema);
  const updatedItemsToDisplay = getUpdatedItemsToDisplay({
    inheritedFilters,
    parentEntityData,
    itemsToDisplay,
    parentSchema
  });
  const variableProps = {
    sortProperties: updatedSortProperties,
    filterByProperty,
    sortby: null,
    sort: null,
    filterBy
  };
  const updatedFilterBy = getUpdatedFilterBy(inheritedFilters, parentEntityData, filterEntitySchema, parentSchema, parentId, variableProps);
  const {
    variables
  } = filterQuerySetup({
    itemsToDisplay: updatedItemsToDisplay,
    entitySameAsCurrentItemEntity,
    filterEntityRelations,
    entity: filterEntity,
    docType: docTypes,
    getEntitySchemas,
    updatedFilterBy,
    variableProps,
    filterOperator
  });
  variables.limit = props.limit || undefined;
  const hasNoItemsToDisplayOrFilter = !updatedItemsToDisplay.length && !updatedFilterBy;
  const {
    data = {}
  } = useQuery(action, {
    variables,
    skip: shouldReturn(hasNoItemsToDisplayOrFilter, singleItemQueryLoading, singleItemQueryError, entityObjloading, entityObjError, schemaLoading, schemaError)
  });
  const {
    results
  } = data[SEARCH_PUBLISHED_CONTENT] || {};
  if (!results) return null;
  return results.map(item => {
    const itemParent = {
      itemId: item.id,
      itemEntity: graphqlEntityMap[item.__typename]
    };
    return /*#__PURE__*/React.createElement(MenuItemRender, _extends({}, props, {
      parent: itemParent,
      url: item.url || props.url
    }));
  });
};
MenuEntitiesItem.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  eventType: PropTypes.string.isRequired,
  modifier: PropTypes.string,
  parent: PropTypes.object,
  text: PropTypes.string,
  url: PropTypes.string,
  entities: PropTypes.array,
  limit: PropTypes.number,
  offset: PropTypes.number,
  sortby: PropTypes.array,
  filterBy: PropTypes.array,
  sort: PropTypes.string,
  operator: PropTypes.string.isRequired,
  filterOperator: PropTypes.string.isRequired,
  sortProperties: PropTypes.array,
  filterByProperty: PropTypes.array,
  itemsToDisplay: PropTypes.array
};
MenuEntitiesItem.defaultProps = {
  children: null,
  modifier: '',
  limit: 0,
  offset: 0,
  itemsToDisplay: [],
  sort: '',
  sortby: [],
  sortProperties: [],
  filterByProperty: [],
  parent: {},
  filterBy: [],
  text: '',
  url: '',
  entities: []
};
export default MenuEntitiesItem;
//# sourceMappingURL=MenuEntitiesItem.js.map